import { INTERNAL_ROLES } from "../../../utils/Roles";
import userHasAccess from "../../../utils/userHasAccess";
import { RECURRING } from "../../dashboard/clients/enums/billingPeriodTypes";
import { TED_DESJARDINS } from "../../dashboard/clients/enums/synchronizationOptions";

export const canViewActivationStatus = (clientBillingPeriodType, isMintEnabledResponse, syncType) => {
    return userHasAccess(INTERNAL_ROLES, true) && clientBillingPeriodType === RECURRING.value && isMintEnabledResponse && syncType != TED_DESJARDINS.value
};



// WEBPACK FOOTER //
// ./src/components/common/MemberActivation/memberActivationHelper.js